module.exports = __webpack_public_path__ + "static/media/export-card-pagebreak.0ce29876.png";